import Navigation from './navigation';
import React  from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import { ChakraProvider, VStack } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools'
import theme from './components/Theme';
import './i18n';

import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/ubuntu/500.css';
import '@fontsource/ubuntu/700.css';
import '@fontsource/inter/200.css';
import '@fontsource/inter/300.css';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';

const container = document.getElementById('root');
const root =  createRoot(container!);
const queryClient = new QueryClient();


root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={theme}>
          <VStack>
            <Navigation />
          </VStack>
        </ChakraProvider>
        <ReactQueryDevtools initialIsOpen={false}  />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,

);
